import { render } from "./LinkText.vue?vue&type=template&id=17fe8257&scoped=true&ts=true"
import script from "./LinkText.vue?vue&type=script&lang=ts"
export * from "./LinkText.vue?vue&type=script&lang=ts"

import "./LinkText.vue?vue&type=style&index=0&id=17fe8257&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17fe8257"]])

export default __exports__